import React from 'react';

/** Shared plus icon: two overlapping rounded rects + plus. Used in card (header) and list row; only colors differ. */
export interface QuestionnaireAddIconProps {
  /** Back/shadow layer fill (card: rgba(255,255,255,0.38), list: #B8BEC9) */
  backFill?: string;
  /** Front layer fill (card: #ffffff, list: #99A1AF) */
  frontFill?: string;
  /** Plus stroke color (card: #25A8DA, list: #fff) */
  plusStroke?: string;
  size?: number;
  width?: number;
  height?: number;
  tall?: boolean;
}

const CARD_BACK = 'rgba(255,255,255,0.38)';
const CARD_FRONT = '#ffffff';
const CARD_PLUS = '#25A8DA';

export function QuestionnaireAddIcon({
  backFill = CARD_BACK,
  frontFill = CARD_FRONT,
  plusStroke = CARD_PLUS,
  size = 22,
  width,
  height,
  tall = false,
}: QuestionnaireAddIconProps) {
  const iconWidth = width ?? size;
  const iconHeight = height ?? size;

  const backRect = tall
    ? { x: 3.5, y: 1, width: 11.5, height: 16, rx: 3 }
    : { x: 3, y: 2, width: 12, height: 12, rx: 4 };
  const frontRect = tall
    ? { x: 7, y: 5, width: 12, height: 16, rx: 3 }
    : { x: 7, y: 6, width: 12, height: 12, rx: 4 };
  const plus = tall
    ? { x: 13, y1: 10, y2: 16, y: 13, x1: 11, x2: 15 }
    : { x: 13, y1: 9.75, y2: 14.25, y: 12, x1: 10.75, x2: 15.25 };

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x={backRect.x}
        y={backRect.y}
        width={backRect.width}
        height={backRect.height}
        rx={backRect.rx}
        fill={backFill}
      />
      <rect
        x={frontRect.x}
        y={frontRect.y}
        width={frontRect.width}
        height={frontRect.height}
        rx={frontRect.rx}
        fill={frontFill}
      />
      <path d={`M${plus.x} ${plus.y1}V${plus.y2}`} stroke={plusStroke} strokeWidth="1.8" strokeLinecap="round" />
      <path d={`M${plus.x1} ${plus.y}H${plus.x2}`} stroke={plusStroke} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
